/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */
function stripHtml(html){
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.innerHTML || "";
}
(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span class="sr-only">Original Price</span><span>' +
        formatPrice(compare_at_price).replace('.00','') +
        '</span></span> ';
      res += '<b class="main_pric_with_com_price"><span class="sr-only">Current Price</span>' + formatPrice(price) + '</b>';
//       res +=
//         ' <span class="ais-hit--price-discount" style="font-weight: ' +
//         Math.floor(discount_ratio * 10) * 100 +
//         ';">-' +
//         Math.floor(discount_ratio * 100) +
//         '%</span>';
    }
    else{
    	res = '<span class="sr-only">Current Price</span><b>' + formatPrice(price).replace('.00','') + '</b>';
    }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','') + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    autocompleteProductPrice: function autocompleteProductPrice(){
      if (this._distinct) {
        var price = this.price;
        if (this.compare_at_price != null){
          if (this.price < this.compare_at_price) {
            return '<del>'+ formatPrice(this.compare_at_price).replace('.00','') +'</del><span class="autocomplete_compare_price">'+ formatPrice(this.price).replace('.00','') +'</span>';
          } else {
            if (this._distinct) {
              var min = this.variants_min_price;
              var max = this.variants_max_price;
              if (min !== max) {
                return formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','');
              }
            }
          }
        } 
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','') + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      // if (window.location.href.indexOf('utm') > -1) {
      //   var utm_parameter = addVariantId ? '&' + window.location.href.split('?')[1] : '?' + window.location.href.split('?')[1];
      // }
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
        // (utm_parameter ? utm_parameter : '')
      );
    },
    hoverImage: function hoverImage() {
      var new_neta = this.meta;
     if (Object.keys(new_neta).length !== 0){
        var hoverimage = this._distinct ? this.meta.custom.hover_image : this.image;
        if (!hoverimage) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }
         return '<img class="hoveredImage" src="'+hoverimage+'" alt="'+this.title+'">';
     }
    },
    instantsizecoloroptions: function instantsizecoloroptions() {
      var __this = this;
      var tag = __this.tags;
      var current_tag = 'swatch_tag_' + __this.handle
      if(tag.indexOf(current_tag) > -1 ){
        $.get('/collections/all/'+current_tag+'?view=algolia_plp',function(data){
          var new_data =  data.split('[splitttt]');
          $('[data-variant-id="'+__this.objectID+'"] .swatch_wrap').html(new_data[0]);
          $('[data-variant-id="'+__this.objectID+'"] .ais-hit--color-count').html(new_data[1]);
          $('[data-variant-id="'+__this.objectID+'"] .quick_view_sizes').html(new_data[2]);
        }).error(function(event, jqxhr, exception) {
        });
      }
      else{
        $.get( '/products/'+__this.handle +'?view=color-swatch', function( data ) {
          var new_data =  data.split('[splitttt]');
          // $('[data-variant-id="'+__this.objectID+'"] .swatch_wrap').html(new_data[0]);
          $('[data-variant-id="'+__this.objectID+'"] .ais-hit--color-count').html(new_data[1]);
          $('[data-variant-id="'+__this.objectID+'"] .quick_view_sizes').html(new_data[2]);
        }).error(function(event, jqxhr, exception) {
        });
      }
       
    },
    productbadge: function productbadge() {
      var new_tags = this.tags;
      if( this.compare_at_price > this.price ){
          let percentage = Math.trunc((this.compare_at_price - this.price) / this.compare_at_price * 100);
          var finalPercentage = percentage % 5 === 0 ? percentage : Math.round(percentage / 10) * 10
          return '<span class="new_product_badge ab_sale_badge">Sale</span><span class="new_product_badge ab_dis_sale_badge">'+ finalPercentage +'% OFF</span>'
      } else if(new_tags.indexOf('SELLINGFAST') > 1 ){
          return '<span class="new_product_badge">SELLING FAST</span>'
      } else if(new_tags.indexOf('TOPRATED') > 1 ){
          return '<span class="new_product_badge">TOP RATED</span>'
      } else if(new_tags.indexOf('BIS') > 1 ){
          return '<span class="new_product_badge">BACK IN STOCK</span>'
      } else if(new_tags.indexOf('EXTENDEDCALF') > 1 || new_tags.indexOf('Extendedcalf') > 1 || new_tags.indexOf('extendedcalf') > 1 ){
          return '<span class="new_product_badge">WIDE CALF</span>'
      } else if(new_tags.indexOf('EXCLUSIVE') > 1 || new_tags.indexOf('Exclusive') > 1 || new_tags.indexOf('exclusive') > 1 ){
          return '<span class="new_product_badge">EXCLUSIVE</span>'
      } else if(new_tags.indexOf('new') > -1 || new_tags.indexOf('New') > 1 || new_tags.indexOf('NEW') > 1 ){
	      return '<span class="new_product_badge">New</span>'
      } else if(new_tags.indexOf('best-seller') > 1 || new_tags.indexOf('Best-seller') > 1 || new_tags.indexOf('bestseller') > 1 || new_tags.indexOf('BESTSELLER') > 1 || new_tags.indexOf('best seller') > 1 || new_tags.indexOf('Best seller') > 1){
	      return '<span class="new_product_badge">Best Seller</span>'
      } else if(new_tags.indexOf('WIDE') > 1 || new_tags.indexOf('Wide') > 1 || new_tags.indexOf('wide') > 1 ){
	      return '<span class="new_product_badge">Wide</span>'
      } else if(new_tags.indexOf('WATERPROOF') > 1 || new_tags.indexOf('Waterproof') > 1 || new_tags.indexOf('waterproof') > 1 ){
	      return '<span class="new_product_badge">Waterproof</span>'
      }
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value.toLowerCase()
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      if (res.includes('h2o') > -1){
        res = res.replace('h2o','H2O');
      }
      return res
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;
        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
